import styled from 'styled-components'
import { colors } from '../../theme'

export const Container = styled.div`
  background: ${colors.surface};
  padding: 30px;
  border-radius: 24px;
`
export const WrapperTop = styled.div`
  display: flex;
  justify-content: space-between;
  font-family: 'Sora';
  color: ${colors.white};
  font-size: 22px;
  line-height: 150%;
  font-weight: 600;
  margin-bottom: 20px;
`
export const WrapperCards = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 40px;
  @media screen and (max-width: 1400px) {
    gap: 20px;
  }
`

// Grid de 4 colunas para as telas de detalhe (Produto/Cliente/Vendedor/Empresa):
// os 7 cards fluem em 2 linhas (4 + 3), com larguras uniformes e a 4ª célula da
// 2ª linha vazia. Separado de WrapperCards para não afetar o Dashboard.
export const WrapperCardsResumo = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 40px;
  @media screen and (max-width: 1400px) {
    gap: 20px;
  }
  @media screen and (max-width: 1000px) {
    grid-template-columns: repeat(2, 1fr);
  }
`

type SpanSelectProps = 'BLUE' | 'GREY'

export const SpanSelect = styled.span<{ color: SpanSelectProps }>`
  color: ${colors.grey800};
  font-size: 12px;
  margin-left: 5px;
`
export const DivSelect = styled.div`
  border-radius: 10px;
  display: flex;
  align-items: right;
  position: relative;
  height: 38px;
  padding: 0 10px;
  margin-top: 10px;
`

export const Select = styled.select`
  color: ${colors.primaryText};
  border-style: hidden;
  -webkit-appearance: none;
  padding: 0 24px 0 5px;
  background-color: ${colors.mask1};
  font-weight: 800;
  font-size: 12px;
  z-index: 0;
`
export const DivDown = styled.div`
  position: absolute;
  right: 13px;
  bottom: -4px;
  z-index: 0;
`

export const WrapperTable = styled.div`
  width: 49%;
  padding: 20px;
  box-shadow: 0px 7px 30px rgba(0, 0, 0, 0.28);
  border-radius: 24px;
  background-color: ${colors.surface};
  align-items: end;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`
export const TitleTable = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`
export const Div = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 30px;
`

export const DivTablePaginacao = styled.div`
  width: 100%;
`
